"use client";

import * as React from "react";
import { Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu className="block max-w-full justify-start" viewport={false}>
      <NavigationMenuList className="flex-col items-start space-x-0 gap-3">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} className="w-full" data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium block w-full text-left">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark text-foreground py-16 border-t border-border/10 !bg-[hsl(239,35%,24%)]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8 mb-16 items-start">
          {}
          <div className="flex flex-col gap-6 text-left">
            <Link to="/" className="block w-fit">
              <h1 className="tracking-tight text-foreground !font-normal !text-lg text-left">DCLegal</h1>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs !text-justify">DCLegal offre assistenza legale specializzata in compliance, corporate governance e contrattualistica, con solide competenze in 231, privacy e intelligenza artificiale (AI).</p>
          </div>

          {}
          <div className="flex flex-col gap-6 text-left">
            
            <MenuProvider menu_id="43">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div className="lg:col-span-1"></div>

          <div className="lg:col-span-1"></div>

          {}
          <div className="flex flex-col gap-6 text-left">
            <h3 className="text-lg tracking-wide text-foreground !font-sans !font-medium text-left">Contatti</h3>
            <div className="flex flex-col gap-4 text-sm text-muted-foreground">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-primary shrink-0" />
                <span>Via San Vittore al Teatro 3 <br />20123 Milano (MI)</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-primary shrink-0" />
                <Link to="tel:+390249675955" className="hover:text-primary transition-colors">+39 02 496 75 955</Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary shrink-0" />
                <Link to="mailto:info@studiodclegal.it" className="hover:text-primary transition-colors">info@studiodclegal.it</Link>
              </div>
            </div>

            <div className="flex items-center gap-4 mt-2">
              {[{
              icon: Linkedin,
              href: "https://www.linkedin.com/company/dclegal-studio-legale/"
            }].map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} newTab className="text-muted-foreground hover:text-primary transition-colors">
                    <Icon className="w-5 h-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="bg-border/20 mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground/60">
          <p>
            &copy; {currentYear} DCLegal. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-6">
            <Link to="https://studiodclegal.it/privacy-policy/" className="hover:text-primary transition-colors">
  Privacy Policy
          </Link>

            <a href="https://studiodclegal.it/dclegal_cookie-policy/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">
  Cookie Policy
</a>



            <Link to="#" className="hover:text-primary transition-colors">
              Note Legali
            </Link>
          </div>
        </div>
      </div>
    </section>;
}